import api, { configApi, formApi } from "../api";
import { GetAllDownlines, GetDownlineById } from "./UsersSlice";

const UsersModule = () => {
  return {
    ChangePin: function (data) {
      return api.post("identity/Agent/changepin", data);
    },

    //Agents
    SuperdealerAgents: function (data) {
      return api.get("identity/Superdealer/agents", data);
    },

    SingleSuperdealerAgents: function (data) {
      return api.get(`identity/Superdealer/agents/${data}?id=${data}`, data);
    },

    UpdateSuperdealerAgents: function (data) {
      return api.post(`identity/Superdealer/agents/updateagent`, data);
    },

    GetSuperdealerAgentsProducts: function (data) {
      return api.get(
        `identity/Superdealer/products/agent/${data}?agentId=${data}`,
        data
      );
    },

    //Resellers
    SuperdealerResellers: function (data) {
      return api.get("identity/Superdealer/reseller", data);
    },

    SingleSuperdealerResellers: function (data) {
      return api.get(`identity/Superdealer/reseller/${data}?id=${data}`, data);
    },

    UpdateSuperdealerReseller: function (data) {
      return api.post(`identity/Agent/superdealer/agents/update`, data);
    },

    GetSuperdealerResellerProducts: function (data) {
      return api.get(
        `identity/Superdealer/products/reseller/${data}?agentId=${data}`,
        data
      );
    },

    BulkUploadAgent: function ({ agentRole, fileData }) {
      console.log("dataaaa", { agentRole, fileData });
      return formApi.post(`identity/Agent/uploadagents/${agentRole}`, fileData);
    },

    AgentSearch: function (data) {
      return api.get(
        `identity/Agent/agents/search?EmailAddress=${data.email}&MobileNumber=${data.phone}`
      );
    },

    //products
    getProducts: function (data) {
      return api.get(`identity/Agent/products`);
    },

    // /Agent/reseller/onboardagent
    OnboardAgent: function (data) {
      return api.post("identity/Agent/reseller/onboardagent", data);
    },

    // EnableAction
    EnableAction: function (data) {
      const { AgentId, Type } = data;
      return api.post(
        `identity/Agent/downline/settings/activate?AgentId=${AgentId}&Activate=true&Type=${Type}`
      );
    },

    // DisableAction
    DisableAction: function (data) {
      const { AgentId, Type } = data;
      console.log("holy", data);
      return api.post(
        `identity/Agent/downline/settings/deactivate?AgentId=${AgentId}&Activate=false&Type=${Type}`
      );
    },

    // ActivateCustomers
    ActivateCustomers: function (data) {
      return api.post("identity/Agent/agents/activateuser", data);
    },

    // DeactivateCustomers
    DeactivateCustomers: function (data) {
      return api.post("identity/Agent/agents/deactivateuser", data);
    },

    // AddMoreProducts
    AddMoreProducts: function (data) {
      return api.post(
        "identity/Agent/superdealer/agents/products/create",
        data
      );
    },

    // Customerroducts
    CustomerProductsAgent: function (data) {
      // return api.get(`identity/ProductAdmin/products/agent/${data}`, data);
      return api.get(`identity/agent/downline/product/${data}`, data);
    },

    // Customerroducts
    CustomerProductsResseller: function (data) {
      // return api.get(`identity/ProductAdmin/products/reseller/${data}`, data);
      return api.get(`identity/agent/downline/product/${data}`, data);
    },

    CustomerProductsRessellerAndAgent: function (data) {
      return api.get(`identity/AgentProduct/downline/${data}`, data);
    },

    // UpdateCustomerProducts
    UpdateCustomerProducts: function (data) {
      return api.post(`identity/AgentProduct/agent/status/update`, data);
    },

    // /Admin/superdealer/agents/product/commission/update
    UpdateCustomerCommission: function (data) {
      return api.post(
        `identity/Agent/superdealer/agents/product/commission/update`,
        data
      );
    },

    // UpdateCommission
    UpdateCommission: function (data) {
      return api.post(`/identity/Agent/product/bulkupdate`, data);
    },

    //list of customers
    ListCustomers: function (data) {
      //console.log("tttttttt", data);
      return api.get(
        `identity/Agent/downlines?PageSize=${data.pageSize}&CurrentPage=${data.currentPage}&SearchText=${data.keyword}`
      );
    },

    //list of ListMerchants
    ListMerchants: function (data) {
      //console.log("tttttttt", data);
      return api.get(
        `identity/Agent/wipay/merchants?PageSize=${data.pageSize}&CurrentPage=${data.currentPage}&SearchText=${data.keyword}`
      );
    },

    // list of ListTerminals

    ListTerminals: function (data) {
      //console.log("tttttttt", data);
      return api.get(
        `identity/Agent/wipay/terminals?PageSize=${data.pageSize}&CurrentPage=${data.currentPage}&SearchText=${data.keyword}&MerchantId=${data.merchantId}`
      );
    },

    ListCustomerWallets: function (data) {
      //console.log("tttttttt", data);
      return api.get(`/identity/Agent/subwallet/${data}?id=${data}`);
    },

    // flexmonie ***********************************
    // https://onboarding-dev.flexmonie.com/v1/api/Customer/validate-customer
    ValidateCustomer: function (data) {
      return api.post(`Customer/validate-customer`, data);
    },

    // https://onboarding-dev.flexmonie.com/v1/api/Agent
    OnboarDownline: function (data) {
      return api.post("/Agent", data);
    },

    CurrentUser: function (data) {
      return api.get("Auth/sessiondetails");
    },

    GetAllDownlines: function (data) {
      let url = `Agent?PageSize=${data.pageSize}&Page=${data.currentPage}`;

      if (data.keyword) {
        url += `&SearchText=${encodeURIComponent(data.keyword)}`;
      }

      return api.get(url);
    },

    GetAggregatorDownlines: function (data) {
      let url = `superdealer/my-aggregator-downline?PageSize=${data.pageSize}&Page=${data.currentPage}`;
      if (data.keyword) {
        url += `&SearchText=${encodeURIComponent(data.keyword)}`;
      }
      return api.get(url);
    },

    GetDownlineById: function (data) {
      return api.get(`Agent/${data}`);
    },

    SuperdealerDetails: function (data) {
      return api.get(`Superdealer/${data}`);
    },

    GetAllAggregators: function (data) {
      let url = `Aggregator?PageSize=${data.pageSize}&Page=${data.currentPage}`;

      if (data.keyword) {
        url += `&SearchText=${encodeURIComponent(data.keyword)}`;
      }

      return api.get(url);
    },

    GetAggregatorById: function (data) {
      return api.get(`Aggregator/${data}`);
    },

    GetAggregatorProducts: function (data) {
      let url = `AggregatorProduct/AggregatorProducts?walletId=${data.walletId}`;

      return configApi.get(url);
    },

    GetDownlineProducts: function (data) {
      let url = `DownlineProduct/DownlineProducts?walletId=${data.walletId}`;

      return configApi.get(url);
    },

    // DownlineProduct/ActivateDownlineProduct?Id=11
    ActivateDownlineProduct: function (data) {
      return configApi.post(
        `DownlineProduct/ActivateDownlineProduct?Id=${data}`,
        data
      );
    },

    DeactivateDownlineProduct: function (data) {
      return configApi.post(
        `DownlineProduct/DeactivateDownlineProduct?Id=${data}`,
        data
      );
    },

    //https://config-dev.flexmonie.com/v1/api/SuperDealer/Products
    GetSuperDealerProducts: function (data) {
      return configApi.get(`SuperDealer/GetAllProductsForSuperDealer?walletId=${data}&pageSize=1000&pageNumber=1`);
    },

    // https://config-dev.flexmonie.com/v1/api/SuperDealer/GetAllProductsForSuperDealer?walletId=${data.walletId}&pageSize=1000&pageNumber=1

    // https://config-dev.flexmonie.com/v1/api/SuperDealer/EditProduct
    EditSuperDealerProducts: function (data) {
      return configApi.post(`SuperDealer/EditProduct`, data);
    },
  };
};

export const UsersService = {
  usersModule: UsersModule,
};
